import React, { useEffect, useState } from 'react';
import { fetchImage } from '../api/unsplash';

const FeaturesSection = ({ features, data }) => {
  const [featuresWithImages, setFeaturesWithImages] = useState([]);

  useEffect(() => {
    const fetchImagesForFeatures = async () => {
      const featuresWithImagesData = await Promise.all(
        features.map(async (feature) => {
          const imageUrl = await fetchImage(feature.Benefit_name + feature.Benefit_description);
          return { ...feature, imageUrl };
        })
      );
      setFeaturesWithImages(featuresWithImagesData);
    };

    fetchImagesForFeatures();
  }, [features]);

  return (
    <div className="features-section bg-gray-50 py-12">
      <h2 className="text-center text-3xl font-extrabold text-gray-800 mb-10">Beneficios</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 px-4 lg:px-16">
        {featuresWithImages.map((feature, index) => (
          <div
            key={index}
            className="feature-card bg-white shadow-lg rounded-xl overflow-hidden hover:shadow-xl transition-shadow duration-300"
          >
            {feature.imageUrl && (
              <div className="relative w-full h-48">
                <img
                  src={feature.imageUrl}
                  alt={feature.Benefit_name}
                  className="w-full h-full object-cover"
                />
              </div>
            )}
            <div className="p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-2">{feature.Benefit_name}</h3>
              <p className="text-gray-600">{feature.Benefit_description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturesSection;
